import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@/ui/components/icon/Icon';
  import { Button } from '@/ui/components/Button';
  import { useCourseTakeStore } from '@/stores/trainings/courseTake';
  import { toasted } from '@/ui/helpers';
  import { router } from '@/ui/routes';
  import { storeToRefs } from 'pinia';
  import { Loading } from '@/ui/components/Loading';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Completed',
  setup(__props) {

  const courseTake = useCourseTakeStore();
  const { isLoading } = storeToRefs(courseTake);

  const handleSubmit = async () => {
    try {
      await courseTake.submit();
      router.push({ name: 'courses', query: { tab: 'completed' } });
    } catch (e) {
      console.error('Failed to submit course:', e);
      toasted.error(`Failed to submit course: ${(e as Error).message}`);
    }
  };

return { __sfc: true,courseTake, isLoading, handleSubmit, Icon, Button, Loading }
}

})